import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';



import { AlertService } from '../../../providers/alert-service';
import { OcorrenciasService } from '../../../providers/ocorrencias-service';
import { RolresponsaveisService } from '../../../providers/rolresponsaveis-service';
import { TiposIrregularidadesService } from '../../../providers/tipos-irregularidades-service';

import { IMyDpOptions } from 'mydatepicker';
import { IMyDrpOptions, IMyDateRangeModel, IMyDateRange } from 'mydaterangepicker';

/*
  Generated class for the ModalOcorrencia page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-modal-ocorrencia',
  templateUrl: 'modal-ocorrencia.html',
  providers: [
    OcorrenciasService,
    TiposIrregularidadesService
  ]
})
export class ModalOcorrenciaPage {

  loading: any = false;
  view: any = false;
  viewResp: any = false;
  viewEmp: any = false;
  listaIrregularidades: any = [];
  ocorrenciasRegistradas: any = [];
  responsavelocorrencia: any = [];
  listaClassificacoes: any = [];
  listaReposaveisOcorrencias: any = [];
  empresas: any = [];
  empresa: any = {
    "id": 0,
    "nome": "",
    "cnpj": "",
    "dsConduta": "",
    "dsNexo": ""
  };
  empresaAtual: any;

  comboIrregularidadeNome: any;
  comboResponsavel: any;
  comboEmpresa: any;
  comboIrregularidadeClassificacao: any;
  objetoProvisorioReponsavel: any = [];
  analise: any = [];

  comboIrregularidadeClassificacaoHabilitado: boolean = false;
  pertenceAoRol: boolean = false;

  visualizarOcorrencias: boolean = true;
  adionaPessoa: boolean = false;
  adicionaEmpresa: boolean = false;

  salvarPessoaOuEmpresa: boolean = false;
  pessoaOuEmpresa: any = 1;

  private myDateRangePickerOptions: IMyDrpOptions;
  selectedDateRange: IMyDateRange;

  responsavelAtual: any = {
    "idOcorrenciaPessoa": 0,
    "idOcorrencia": 0,
    "pessoa": {
      "idPessoa": 0,
      "nomePessoa": "",
      "cpf": "",
      "cargo": "",
      "emailPessoal": "",
      "emailFuncional": "",
      "enderecoPessoal": {
        "idEndereco": 0,
        "logradouro": "",
        "numero": "",
        "complemento": "",
        "bairro": "",
        "idCidade": 0,
        "cidade": "",
        "idEstado": 0,
        "estado": "",
        "cep": "",
        "tipoEndereco": ""
      },
      "enderecoFuncional": {
        "idEndereco": 0,
        "logradouro": "",
        "numero": "",
        "complemento": "",
        "bairro": "",
        "idCidade": "",
        "cidade": "",
        "idEstado": "",
        "estado": "",
        "cep": "",
        "tipoEndereco": ""
      },
      "telefones": [],
      "categoria": ""
    },
    "periodo": {
      "idPeriodoFuncao": 0,
      "dataInicio": "",
      "dataFim": "",
      "idPessoaFuncao": 0,
      "portarias": []
    },
    "idFuncao": 0,
    "idCargo": 0,
    "cargo": "",
    "dsConduta": "",
    "dsNexo": "",
    "vinculoCargo": ""
  };

  objeto: any;
  idModulo: any;
  idModuloPca: any;
  idModuloAnalise: any;
  idPCA: any;

  dsNexo: any;
  dsConduta: any;
  vinculo: any;
  pessoa: any;

  cnpjInvalido: any = false;
  cnpjPreenchido: any = false;
  cnpjCarregado: any = true;

  listaPeriodoFuncao: any = [];

  periodoFuncaoParaAdicionar: any = {
    "idPeriodoFuncao": 0,
    "dataInicio": "",
    "dataFim": "",
    "idPessoaFuncao": 0,
    "portarias": []
  }

  selectedText: string = '';
  border: string = 'none';
  comboCargos: any = [];
  empresasParaAdicionar: any = [];
  cargoAtual: any = [];

  constructor(private viewCtrl: ViewController,
    public navParams: NavParams,
    public ocorrenciasService: OcorrenciasService,
    public tiposIrregularidadesService: TiposIrregularidadesService,
    public rolresponsaveisService: RolresponsaveisService,
    private alertService: AlertService) {
    this.carregaModal();

    this.myDateRangePickerOptions = {
      dateFormat: 'dd/mm/yyyy',
      dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
      monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
      firstDayOfWeek: 'su',
      showApplyBtn: false,
      showClearDateRangeBtn: false,
      selectBeginDateTxt: 'Selecione a Data de Início',
      selectEndDateTxt: 'Selecione a Data de Fim',
      openSelectorOnInputClick: true,
      editableDateRangeField: false,
      width: '100%',
      showSelectorArrow: false
    };

  }

  abrirTelaCadastroOcorrencia() {
    this.visualizarOcorrencias = false;
    this.view = false;
    this.viewResp = false;
    this.cpfPreenchido = false;
    this.cnpjPreenchido = false;
    this.viewEmp = false

    this.responsavelAtual = {
      "idOcorrenciaPessoa": 0,
      "idOcorrencia": 0,
      "pessoa": {
        "idPessoa": 0,
        "nomePessoa": "",
        "cpf": "",
        "cargo": "",
        "emailPessoal": "",
        "emailFuncional": "",
        "enderecoPessoal": {
          "idEndereco": 0,
          "logradouro": "",
          "numero": "",
          "complemento": "",
          "bairro": "",
          "idCidade": 0,
          "cidade": "",
          "idEstado": 0,
          "estado": "",
          "cep": "",
          "tipoEndereco": ""
        },
        "enderecoFuncional": {
          "idEndereco": 0,
          "logradouro": "",
          "numero": "",
          "complemento": "",
          "bairro": "",
          "idCidade": "",
          "cidade": "",
          "idEstado": "",
          "estado": "",
          "cep": "",
          "tipoEndereco": ""
        },
        "telefones": [],
        "categoria": ""
      },
      "periodo": {
        "idPeriodoFuncao": 0,
        "dataInicio": "",
        "dataFim": "",
        "idPessoaFuncao": 0,
        "portarias": []
      },
      "idFuncao": 0,
      "idCargo": 0,
      "cargo": "",
      "dsConduta": "",
      "dsNexo": "",
      "vinculoCargo": ""
    };

    this.empresa = {
      "cnpj": "",
      "id": 0,
      "nome": ""
    };

    this.comboIrregularidadeNome = null;
    this.objeto = null;
    this.objetoProvisorioReponsavel = [];

    this.carregaModal()
  }

  responsavelPertenceAoRol() {
    if (this.pertenceAoRol) {
      this.listaPeriodoFuncao = [];
    }
  }

  onDateRangeChanged(event: IMyDateRangeModel) {

    if (event.formatted !== '') {
      console.log("this.periodoFuncaoParaAdicionar");
      console.log(this.periodoFuncaoParaAdicionar);

      this.border = '1px solid #CCC';

      this.periodoFuncaoParaAdicionar.dataInicio = new Date(event.beginJsDate).toLocaleDateString('pt-br');
      this.periodoFuncaoParaAdicionar.dataFim = new Date(event.endJsDate).toLocaleDateString('pt-br');
    }
    else {
      this.selectedText = '';
      this.border = 'none';
    }
  }

  carregarCargos() {
    this.rolresponsaveisService.buscarCargos().subscribe(data => {
      this.comboCargos = data;
    },
      error => {
        console.log("erro: " + error);
      });
  }

  adicionarPeriodoFuncao() {
    if (this.periodoFuncaoParaAdicionar.dataInicio != '' &&
      this.periodoFuncaoParaAdicionar.dataFim != '') {
      let periodoFuncaoNovo = {
        "idPeriodoFuncao": 0,
        "dataInicio": this.periodoFuncaoParaAdicionar.dataInicio,
        "dataFim": this.periodoFuncaoParaAdicionar.dataFim,
        "idPessoaFuncao": 0,
        "portarias": []
      };
      console.log("this.periodoFuncaoParaAdicionar");
      console.log(this.periodoFuncaoParaAdicionar);
      if (this.responsavelAtual.periodo.dataInicio === periodoFuncaoNovo.dataInicio &&
        this.responsavelAtual.periodo.dataFim === periodoFuncaoNovo.dataFim) {
        this.alertService.mostraAlerta("", "Período já adicionado!");
      }
      else {

        this.clearDateRange();
        this.listaPeriodoFuncao.push(periodoFuncaoNovo);
        this.responsavelAtual.periodo = periodoFuncaoNovo;
        this.periodoFuncaoParaAdicionar.dataInicio =
          this.periodoFuncaoParaAdicionar.dataFim = '';
      }
    }
  }

  clearDateRange(): void {
    this.selectedDateRange = null;
  }

  removerPeriodoFuncao(periodoFuncao) {

    let index = this.listaPeriodoFuncao.indexOf(periodoFuncao);
    this.listaPeriodoFuncao.splice(index, 1);

    // if (periodoFuncao.idPeriodoFuncao != 0) {
    //   this.periodosParaRemover.push(periodoFuncao);
    // }

    if (periodoFuncao.idPeriodoFuncao != undefined && periodoFuncao.idPeriodoFuncao > 0) {
      this.rolresponsaveisService.deletarPeriodoFuncao(periodoFuncao.idPeriodoFuncao).subscribe(per => {
        console.log(per.mensagem);
      });
    }
  }

  carregaModal() {
    this.loading = true;
    this.objeto = this.ocorrenciasService.getOcorrenciaVazia();

    this.analise = this.navParams.get('analise');

    this.idPCA = this.navParams.get('idpca');
    this.idModulo = this.navParams.get('idmodulo');
    this.idModuloPca = this.navParams.get('idModuloPca');

    this.listarIrregularidades();
    this.listarResponsaveisOcorrencia();
    this.listarEmpresas();
    this.carregarCargos();
    this.objeto.idPca = this.idPCA;
    this.objeto.irregularidade.modulo.idModuloPca = this.idModuloPca;
    this.objeto.irregularidade.modulo.idModulo = this.idModulo;

    if (this.navParams.get('flag') == "visualizar" && this.visualizarOcorrencias == true) {
      if (this.analise) {
        if (this.analise.cdAnalise != 0) {
          this.ocorrenciasService.listarOcorrenciasPorAnalise(this.idPCA, this.analise.cdAnalise).subscribe(data => {
            this.ocorrenciasRegistradas = data;
            this.visualizarOcorrencias = true;
            this.loading = false;
          }, error => {
            console.log("erro: " + error);
            this.loading = false;
          });
        } else {
          this.ocorrenciasService.listarOcorrenciasPorModulo(this.idPCA, this.idModulo).subscribe(data => {
            this.ocorrenciasRegistradas = data;
            this.visualizarOcorrencias = true;
            this.loading = false;
          }, error => {
            console.log("erro: " + error);
            this.loading = false;
          });
        }
      } else {
        this.ocorrenciasService.listarOcorrenciasPorModulo(this.idPCA, this.idModulo).subscribe(data => {
          this.ocorrenciasRegistradas = data;
          this.visualizarOcorrencias = true;
          this.loading = false;
        }, error => {
          console.log("erro: " + error);
          this.loading = false;
        });
      }
    } else if (this.navParams.get('flag') == "editar") {
      this.objeto = this.ocorrenciasService.getOcorrencia();
      this.visualizarOcorrencias = false;
    } else {
      this.visualizarOcorrencias = false;
    }

    this.carregarEstados();
    this.carregarTiposTelefones();
  }

  visualizaOcorrencias() {
    this.loading = true;
    if (this.analise) {
      if (this.analise.cdAnalise != 0) {
        this.ocorrenciasService.listarOcorrenciasPorAnalise(this.idPCA, this.analise.cdAnalise).subscribe(data => {
          this.ocorrenciasRegistradas = data;
          this.visualizarOcorrencias = true;
          this.view = false;
          this.viewResp = false;
          this.loading = false;
        }, error => {
          console.log("erro: " + error);
          this.loading = false;
        });
      } else {
        this.ocorrenciasService.listarOcorrenciasPorModulo(this.idPCA, this.idModulo).subscribe(data => {
          this.ocorrenciasRegistradas = data;
          this.visualizarOcorrencias = true;
          this.view = false;
          this.viewResp = false;
          this.loading = false;
        }, error => {
          console.log("erro: " + error);
          this.loading = false;
        });
      }
    } else {
      this.ocorrenciasService.listarOcorrenciasPorModulo(this.idPCA, this.idModulo).subscribe(data => {
        this.ocorrenciasRegistradas = data;
        this.visualizarOcorrencias = true;
        this.view = false;
        this.viewResp = false;
        this.loading = false;
      }, error => {
        console.log("erro: " + error);
        this.loading = false;
      });
    }
  }

  listarResponsaveisOcorrencia() {
    this.ocorrenciasService.listarResposaveisPorPCA(this.idPCA).subscribe(data => {
      this.listaReposaveisOcorrencias = data;
      let arrayAdicional = { nomePessoa: "Responsável não indicado no Rol desta Pca" };
      this.listaReposaveisOcorrencias.push(arrayAdicional);


      this.listaReposaveisOcorrencias.map(
        (resp: any) => {
          let cargo = '';
          let categoria = '';

          if (resp.categoria) { categoria = resp.categoria; }
          if (resp.cargo) { cargo = resp.cargo; }
          resp.concatResp = categoria + ' - ' + cargo + ' - ' + resp.nomePessoa
          return resp;
        }
      )

    }, error => {
      console.log("erro: " + error);
    });
  }

  listarEmpresas() {
    this.ocorrenciasService.listarEmpresas().subscribe(data => {
      this.empresas = data;
      let arrayAdicional = { cnpj: '', nome: "Empresa não cadastrada" };
      this.empresas.push(arrayAdicional);


      this.empresas.map(
        (emp: any) => {
          let nome = '';
          let cnpj = '';

          if (emp.cnpj) { cnpj = emp.cnpj; }
          if (emp.nome) { nome = emp.nome; }
          emp.concatEmp = cnpj + ' - ' + nome
          return emp;
        }
      )

    }, error => {
      console.log("erro: " + error);
    });

  }

  listarIrregularidades() {
    this.tiposIrregularidadesService.listarTiposIrregularidadesPorModulo(this.idModulo).subscribe(data => {
      this.listaIrregularidades = data;
    }, error => {
      console.log("erro: " + error);
      this.listaIrregularidades = [{
        nomeIrregularidade: "",
        dsIrregularidade: "",
        codClassificao: "",
        flAtivo: true
      }];
      this.alertService.mostraAlerta("", "Houve um erro em listar as irregularidade.");
    });
  }

  obterEmpresa(cnpj) {
    this.ocorrenciasService.obterEmpresaPorCnpj(cnpj).subscribe(data => {
      this.empresa = data;
    }, error => {
      this.empresa = {
        cnpj: cnpj,
        nome: "",
        id: 0
      }
    });
  }

  populaModal() {
    this.comboIrregularidadeNome = this.listaIrregularidades[0].nomeIrregularidade;
    this.objeto.irregularidade = this.listaIrregularidades[0];

    this.comboIrregularidadeClassificacao = this.listaIrregularidades[0].classificacao.dsClassificacao;
    this.objeto.classificacao = this.listaIrregularidades[0].classificacao;

    if (this.comboIrregularidadeClassificacao == "A classificar") {
      this.comboIrregularidadeClassificacaoHabilitado = true;

      this.ocorrenciasService.tiposIrregularidadesService.listarClassificacao().subscribe(data => {
        this.listaClassificacoes = data;
      }, error => {
        console.log("erro: " + error);
        this.alertService.mostraAlerta("", "Houve um erro em listar as irregularidade.");
      });

    } else {
      this.comboIrregularidadeClassificacaoHabilitado = false;
    }
  }

  onIrregularidadeChange(novoValor) {

    if (novoValor) {
      this.objeto.irregularidade = this.listaIrregularidades.filter((item) => novoValor.nomeIrregularidade == item.nomeIrregularidade)[0];

      if (this.objeto.irregularidade.classificacao.dsClassificacao == "A classificar") {
        this.comboIrregularidadeClassificacaoHabilitado = true;

        this.ocorrenciasService.tiposIrregularidadesService.listarClassificacao().subscribe(data => {
          var lst = new Array();
          if (data instanceof Array) {
            data.forEach(element => {
              if (element.dsClassificacao != "A classificar") {
                lst.push(element);
              }
            });
            this.listaClassificacoes = lst;
          }
        }, error => {
          console.log("erro: " + error);
          this.alertService.mostraAlerta("", "Houve um erro em listar as irregularidade.");
        });
      }
    }
  }

  onResponsavelChange(novoValor) {
    console.log(novoValor);
    if (novoValor != undefined) {
      if (novoValor.nomePessoa == "Responsável não indicado no Rol desta Pca") {
        this.adionaPessoa = true;
        console.log(this.responsavelAtual);
      }
      else {
        // console.log(novoValor);
        // this.objetoProvisorioReponsavel.push(this.listaReposaveisOcorrencias.filter((item) => novoValor == item.nomePessoa)[0]);
        this.adionaPessoa = false;

        this.pessoa = this.listaReposaveisOcorrencias.filter((item) => novoValor.nomePessoa.split(' - ')[0] == item.nomePessoa)[0];
      }
    }
  }

  onCargoChange(novoValor) {
    console.log("novoValor Cargo");
    console.log(novoValor);
    if (novoValor != undefined) {
      this.cargoAtual = this.comboCargos.filter((item) => novoValor.nomeCargo == item.nomeCargo)[0];
    }
  }

  onEmpresaChange(novoValor) {
    console.log(novoValor);
    if (novoValor != undefined) {
      if (novoValor.nome == "Empresa não cadastrada") {
        /*this.empresa = {
          cnpj: "",
          id: 0,
          nome: ""
        };*/
        this.adicionaEmpresa = true;
      }
      else {
        // console.log(novoValor);
        // this.objetoProvisorioReponsavel.push(this.listaReposaveisOcorrencias.filter((item) => novoValor == item.nomePessoa)[0]);
        this.adicionaEmpresa = false;

        this.empresa = this.empresas.filter((item) => novoValor.cnpj == item.cnpj)[0];
        console.log("Empresa no on Change");
        console.log(this.empresa);
        this.empresa.id = novoValor.id;
      }
    }
  }

  adicionarResponsavel() {

    this.salvarPessoaOuEmpresa = false;

    let resp = this.pessoa;


    let responsavelNovo = {
      "idOcorrenciaPessoa": 0,
      "idOcorrencia": 0,
      "pessoa": resp,
      "dsConduta": this.dsConduta,
      "dsNexo": this.dsNexo,
      "periodo": {
        "idPeriodoFuncao": 0,
        "dataInicio": "",
        "dataFim": "",
        "idPessoaFuncao": 0,
        "portarias": []
      },
      "idFuncao": 0,
      "idCargo": 0,
      "cargo": "",
    };

    if (!this.pertenceAoRol) {
      responsavelNovo.periodo = this.periodoFuncaoParaAdicionar;
      responsavelNovo.idCargo = this.cargoAtual.idCargo;
      responsavelNovo.cargo = this.cargoAtual.nomeCargo;
    }

    console.log(responsavelNovo);

    this.objetoProvisorioReponsavel.push(responsavelNovo);

    this.comboResponsavel = this.pessoa = null;
    this.dsNexo = this.dsConduta = '';
  }

  adicionarEmpresa() {

    let emp = this.empresa;

    this.salvarPessoaOuEmpresa = true;

    let empresaNova = {
      "id": 0,
      "nome": this.empresa.nome,
      "cnpj": this.empresa.cnpj,
      "dsConduta": this.dsConduta,
      "dsNexo": this.dsNexo
    };

    this.empresasParaAdicionar.push(empresaNova);

    this.comboEmpresa = this.empresa = null;
    this.dsNexo = this.dsConduta = '';
  }

  onClassificacaoChange(novoValor) {
    let obj = novoValor.split(" - ", 2);
    this.objeto.classificacao = this.listaClassificacoes.filter((item) => obj[1] == item.dsClassificacao)[0];

    if (this.objeto.irregularidade.classificacao.dsClassificacao == "a classificar") {
      this.comboIrregularidadeClassificacaoHabilitado = true;
    }
  }

  fecharModalAdionarResponsavel() {
    this.adionaPessoa = false;
    this.viewResp = false;
  }

  fecharModalAdicionarEmpresa() {
    this.adicionaEmpresa = false;
    this.viewEmp = false;
  }

  salvarModalAdionarResponsavel() {

    this.responsavelAtual.pessoa.cpf = this.responsavelAtual.pessoa.cpf.replace(/[^\w\s]/gi, '');
    // this.responsavelAtual.pessoa.enderecoFuncional.cep = this.responsavelAtual.pessoa.enderecoFuncional.cep.replace('.', '');
    // this.responsavelAtual.pessoa.enderecoPessoal.cep = this.responsavelAtual.pessoa.enderecoPessoal.cep.replace('.', '');

    // this.responsavelAtual.pessoa.enderecoPessoal.tipoEndereco = "RESIDENCIAL";
    // this.responsavelAtual.pessoa.enderecoFuncional.tipoEndereco = "COMERCIAL";

    this.ocorrenciasService.salvarPessoa(this.responsavelAtual.pessoa).subscribe(data => {
      this.adionaPessoa = false;

      this.pessoa = this.responsavelAtual.pessoa;
      let responsavelNovo = this.pessoa;
      responsavelNovo["concatResp"] = this.pessoa.categoria + ' - ' + this.pessoa.cargo + ' - ' + this.pessoa.nomePessoa;

      this.listaReposaveisOcorrencias.push(responsavelNovo);

      //this.comboResponsavel = responsavelNovo;

      this.responsavelAtual = {
        "idOcorrenciaPessoa": 0,
        "idOcorrencia": 0,
        "pessoa": {
          "idPessoa": 0,
          "nomePessoa": "",
          "cpf": "",
          "emailPessoal": "",
          "emailFuncional": "",
          "enderecoPessoal": {
            "idEndereco": 0,
            "logradouro": "",
            "numero": "",
            "complemento": "",
            "bairro": "",
            "idCidade": 0,
            "cidade": "",
            "idEstado": 0,
            "estado": "",
            "cep": "",
            "tipoEndereco": ""
          },
          "enderecoFuncional": {
            "idEndereco": 0,
            "logradouro": "",
            "numero": "",
            "complemento": "",
            "bairro": "",
            "idCidade": "",
            "cidade": "",
            "idEstado": "",
            "estado": "",
            "cep": "",
            "tipoEndereco": ""
          },
          "telefones": [],
          "cargo": "",
          "categoria": ""
        },
        "dsConduta": "",
        "dsNexo": "",
        "periodo": {
          "idPeriodoFuncao": 0,
          "dataInicio": "",
          "dataFim": "",
          "idPessoaFuncao": 0,
          "portarias": []
        },
        "idFuncao": 0,
        "idCargo": 0,
        "cargo": "",
        "vinculoCargo": ""
      };

    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Ocorreu um erro ao cadastrar o responsável:" + error);
    });
  }

  salvarModalAdicionarEmpresa() {

    this.empresa.cnpj = this.empresa.cnpj.replace(/[^\w\s]/gi, '');

    let empresaNova = {
      "id": 0,
      "nome": this.empresa.nome,
      "cnpj": this.empresa.cnpj,
      "dsNexo": this.dsNexo,
      "dsConduta": this.dsConduta
    };

    this.ocorrenciasService.salvarEmpresa(empresaNova).subscribe(data => {
      this.adicionaEmpresa = false;

      empresaNova["concatEmp"] = this.empresa.cnpj + ' - ' + this.empresa.nome;
      this.empresas.push(empresaNova);

      //this.comboResponsavel = responsavelNovo;
      this.empresa = {
        "id": 0,
        "nome": "",
        "cnpj": "",
        "dsNexo": "",
        "dsConduta": "",
        "vinculo": ""
      };

    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Ocorreu um erro ao cadastrar a empresa:" + error);
    });
  }

  finalizarAnalise() {
    this.salvarNovaOcorrencia();
  }

  visualizarResponsavel(responsavel) {

    this.responsavelAtual = responsavel;
    this.onCPFAlterado();

    this.adionaPessoa = true;
    this.viewResp = true;
  }

  removerReponsavel(item) {
    var i = this.objetoProvisorioReponsavel.indexOf(item);
    if (i != -1) {
      this.objetoProvisorioReponsavel.splice(i, 1);
    }
  }

  salvarNovaOcorrencia() {

    let modulo = { idModulo: this.idModulo };

    if (this.analise) {
      let analiseProv = {
        cdAnalise: this.analise.cdAnalise,
        dsDescricaoAnalise: this.analise.dsDescricaoAnalise,
        dsResultadoAnalise: this.analise.dsResultadoAnalise,
        dsStatusAnalise: this.analise.dsStatusAnalise,
        flNaoAplica: this.analise.flNaoAplica,
        idModuloAnalise: this.analise.idModuloAnalise,
        idModuloPca: this.analise.idModuloPca,
        idStatusAnalise: this.analise.idStatusAnalise
      };

      let objetoAnalise = {
        "idOcorrenciaAnalise": 0,
        "idOcorrencia": 0,
        "moduloAnalise": analiseProv
      };

      this.objeto.analise.push(objetoAnalise);
    }
    console.log("Empresa ao salvar");
    console.log(this.empresa);


    console.log("this.salvarPessoaOuEmpresa");
    console.log(this.salvarPessoaOuEmpresa);

    if (this.salvarPessoaOuEmpresa) {
      this.empresa = this.empresasParaAdicionar[0];
      this.objeto.idEmpresa = this.empresa.id;
      this.objeto.cnpj = this.empresa.cnpj;
      this.objeto.empresaNome = this.empresa.nome;
    } else {
      console.log("this.salvarPessoaOuEmpresa");
      console.log(this.objetoProvisorioReponsavel);

      this.objeto.responsaveis = this.objetoProvisorioReponsavel;

    }

    this.objeto.tbModuloPca.idModuloPca = this.idModuloPca;
    this.objeto.tbModulo = modulo;

    this.objeto.classificacao = this.objeto.irregularidade.classificacao;

    console.log("O que é objeto");
    console.log(this.objeto);
    ;
    this.ocorrenciasService.salvarOcorrencia(this.objeto).subscribe(data => {
      this.alertService.mostraAlerta("", "Ocorrência cadastrada com sucesso.");
      this.dismiss();
    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Houve um erro em cadastrar ocorrência.");
    });

  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  visualizarOcorrencia(ocorrencia) {

    this.comboIrregularidadeNome = ocorrencia.irregularidade.nomeIrregularidade;
    this.objeto = ocorrencia;
    this.objetoProvisorioReponsavel = ocorrencia.responsaveis;


    this.visualizarOcorrencias = false;
    this.view = true;
  }

  removerOcorrencia(idOcorrencia) {
    this.ocorrenciasService.deletarOcorrencia(idOcorrencia).subscribe(data => {
      this.alertService.mostraAlerta("", "Ocorrência deletada com sucesso.");
      this.dismiss();
    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Houve um erro na exclusão da ocorrência.");
    });
  }

  buscandoCEPFuncional: boolean = false;
  buscandoCEPPessoal: boolean = false;
  cpfPreenchido: boolean = false;
  cpfCarregado: boolean = true;
  cpfInvalido: boolean = false;
  listaCidadesEnderecoPessoal: any = [];
  listaCidadesEnderecoFuncional: any = [];
  listaEstados: any = [];
  listaTiposTelefone: any = [];
  telefoneParaAdicionar: any = {
    dsContato: '',
    dsTipoContato: ''
  }
  phoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  cepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/];
  cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];


  carregarTiposTelefones() {
    this.rolresponsaveisService.buscarTiposTelefone().subscribe(data => {
      this.listaTiposTelefone = data;
    },
      error => {
        console.log("erro: " + error);
      });
  }

  carregarEstados() {
    this.rolresponsaveisService.buscarEstados().subscribe(data => {
      this.listaEstados = data;
    },
      error => {
        console.log("erro: " + error);
      });
  }

  onCPFAlterado() {
    if (this.validarCPF(this.responsavelAtual.pessoa.cpf)) {
      this.cpfInvalido = false;
      this.buscarPessoaPorCPF(this.responsavelAtual.pessoa.cpf);
    }
    else {
      this.cpfPreenchido = false;
    }
  }

  onCNPJAlterado() {
    if (this.validarCNPJ(this.empresa.cnpj)) {
      this.cnpjInvalido = false;
      this.buscarEmpresaPorCNPJ(this.empresa.cnpj);
    }
    else {
      this.cnpjPreenchido = false;
    }
  }

  cpf_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  validarCPF(cpf) {
    let ehValido = true;

    cpf = cpf.replace(/[^\w\s]/gi, '');

    if (cpf == '') {
      this.cpfInvalido = false;
      return false;
    }

    if (cpf.length != 11) {
      this.cpfInvalido = false;
      return false;
    }

    // Elimina CPFs invalidos conhecidos
    if (cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" ||
      cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" ||
      cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") {
      this.cpfInvalido = true;
      return false;
    }

    // Valida 1o digito
    let add = 0;
    for (let i = 0; i < 9; i++)
      add += parseInt(cpf.charAt(i)) * (10 - i);
    let rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(9))) {
      this.cpfInvalido = true;
      return false;
    }

    // Valida 2o digito
    add = 0;
    for (let i = 0; i < 10; i++) {
      add += parseInt(cpf.charAt(i)) * (11 - i);
    }
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)
      rev = 0;
    if (rev != parseInt(cpf.charAt(10))) {
      this.cpfInvalido = true;
      return false;
    }

    return ehValido;
  }

  buscarPessoaPorCPF(cpf) {
    cpf = cpf.replace(/[^\w\s]/gi, '');

    this.cpfCarregado = false;
    this.rolresponsaveisService.buscarPessoaPorCPF(cpf).subscribe(data => {
      if (data != null &&
        data.idPessoa > 0) {
        this.responsavelAtual.pessoa = data;
        this.carregarCidadesDosEnderecosParaEdicao(this.responsavelAtual.pessoa);
      }
      else {
        this.limparCamposPessoa(false);
      }
      this.cpfPreenchido = this.cpfCarregado = true;
    },
      error => {
        console.log("erro: " + error);
        this.cpfPreenchido = this.cpfCarregado = true;
      });
  }

  buscarEmpresaPorCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\w\s]/gi, '');

    this.cnpjCarregado = false;
    this.ocorrenciasService.obterEmpresaPorCnpj(cnpj).subscribe(data => {
      if (data != null &&
        data.id > 0) {
        this.empresa = data;
        //this.carregarCidadesDosEnderecosParaEdicao(this.responsavelAtual.pessoa);
      }
      else {
        this.limparCamposEmpresa(false);
      }
      this.cnpjPreenchido = this.cnpjCarregado = true;
    },
      error => {
        console.log("erro: " + error);
        this.cnpjPreenchido = this.cnpjCarregado = true;
      });
  }

  limparCamposPessoa(limparCpf = true) {
    this.responsavelAtual.pessoa = {
      "idPessoa": 0,
      "nomePessoa": "",
      "cpf": limparCpf ? '' : this.responsavelAtual.pessoa.cpf
    };
  }

  limparCamposEmpresa(limparCnpj = true) {
    this.empresa = {
      "id": 0,
      "nome": "",
      "cnpj": limparCnpj ? '' : this.empresa.cnpj
    };
  }

  carregarCidadesDosEnderecosParaEdicao(pessoa) {
    this.rolresponsaveisService.buscarCidadesPorEstado(this.responsavelAtual.pessoa.enderecoPessoal.idEstado).subscribe(data => {
      this.listaCidadesEnderecoPessoal = data;
      this.responsavelAtual.pessoa.enderecoPessoal.idCidade = pessoa.enderecoPessoal.idCidade;
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
      console.log("erro: " + error);
    });

    this.rolresponsaveisService.buscarCidadesPorEstado(this.responsavelAtual.pessoa.enderecoFuncional.idEstado).subscribe(data => {
      this.listaCidadesEnderecoFuncional = data;
      this.responsavelAtual.pessoa.enderecoFuncional.idCidade = pessoa.enderecoFuncional.idCidade;
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
      console.log("erro: " + error);
    });
  }

  onCEPAlteradoEnderecoFuncional() {
    if (this.cepValido(this.responsavelAtual.pessoa.enderecoFuncional.cep)) {
      this.buscandoCEPFuncional = true;
      this.rolresponsaveisService.buscarEnderecoPorCEP(this.responsavelAtual.pessoa.enderecoFuncional.cep).subscribe(data => {
        if (data != undefined && !data.erro) {
          this.responsavelAtual.pessoa.enderecoFuncional.logradouro = data.logradouro;
          this.responsavelAtual.pessoa.enderecoFuncional.bairro = data.bairro;

          let estadoTemp = this.listaEstados.filter((estado) => data.uf.toUpperCase() == estado.dsSigla.toUpperCase())[0];
          if (estadoTemp != null) {
            this.responsavelAtual.pessoa.enderecoFuncional.idEstado = estadoTemp.idEstado;
            this.responsavelAtual.pessoa.enderecoFuncional.estado = data.uf;
          }

          this.rolresponsaveisService.buscarCidadesPorEstado(this.responsavelAtual.pessoa.enderecoFuncional.idEstado).subscribe(dataCidades => {
            this.listaCidadesEnderecoFuncional = dataCidades;

            let cidadeTemp = this.listaCidadesEnderecoFuncional.filter((cidade) => data.localidade.toUpperCase() == cidade.nmCidade.toUpperCase())[0];
            if (cidadeTemp != null) {
              this.responsavelAtual.pessoa.enderecoFuncional.idCidade = cidadeTemp.idCidade;
              this.responsavelAtual.pessoa.enderecoFuncional.cidade = data.localidade;
            }
          }, error => {
            console.log("erro: " + error);
          });
        }
        else {
          this.limparCamposEnderecoFuncional();
        }
        this.buscandoCEPFuncional = false;
      },
        error => {
          console.log("erro: " + error);
          this.limparCamposEnderecoFuncional();
          this.buscandoCEPFuncional = false;
        });
    }
    else {
      this.limparCamposEnderecoFuncional();
    }
  }

  onCEPAlteradoEnderecoPessoal() {
    if (this.cepValido(this.responsavelAtual.pessoa.enderecoPessoal.cep)) {
      this.buscandoCEPPessoal = true;
      this.rolresponsaveisService.buscarEnderecoPorCEP(this.responsavelAtual.pessoa.enderecoPessoal.cep).subscribe(data => {
        if (data != undefined && !data.erro) {
          this.responsavelAtual.pessoa.enderecoPessoal.logradouro = data.logradouro;
          this.responsavelAtual.pessoa.enderecoPessoal.bairro = data.bairro;

          let estadoTemp = this.listaEstados.filter((estado) => data.uf.toUpperCase() == estado.dsSigla.toUpperCase())[0];
          if (estadoTemp != null) {
            this.responsavelAtual.pessoa.enderecoPessoal.idEstado = estadoTemp.idEstado;
            this.responsavelAtual.pessoa.enderecoPessoal.estado = data.uf;
          }

          this.rolresponsaveisService.buscarCidadesPorEstado(this.responsavelAtual.pessoa.enderecoPessoal.idEstado).subscribe(dataCidades => {
            this.listaCidadesEnderecoPessoal = dataCidades;

            let cidadeTemp = this.listaCidadesEnderecoPessoal.filter((cidade) => data.localidade.toUpperCase() == cidade.nmCidade.toUpperCase())[0];
            if (cidadeTemp != null) {
              this.responsavelAtual.pessoa.enderecoPessoal.idCidade = cidadeTemp.idCidade;
              this.responsavelAtual.pessoa.enderecoPessoal.cidade = data.localidade;
            }
          }, error => {
            console.log("erro: " + error);
          });
        }
        else {
          this.limparCamposEnderecoPessoal();
        }
        this.buscandoCEPPessoal = false;
      },
        error => {
          console.log("erro: " + error);
          this.limparCamposEnderecoPessoal();
          this.buscandoCEPPessoal = false;
        });
    }
    else {
      this.limparCamposEnderecoPessoal();
    }
  }

  cepValido(cep) {
    return cep.toString().replace('-', '').length == 8;
  }

  limparCamposEnderecoFuncional() {
    this.responsavelAtual.pessoa.enderecoFuncional.logradouro
      = this.responsavelAtual.pessoa.enderecoFuncional.bairro
      = this.responsavelAtual.pessoa.enderecoFuncional.idEstado
      = this.responsavelAtual.pessoa.enderecoFuncional.estado
      = this.responsavelAtual.pessoa.enderecoFuncional.idCidade
      = this.responsavelAtual.pessoa.enderecoFuncional.cidade = "";
  }

  limparCamposEnderecoPessoal() {
    this.responsavelAtual.pessoa.enderecoPessoal.logradouro
      = this.responsavelAtual.pessoa.enderecoPessoal.bairro
      = this.responsavelAtual.pessoa.enderecoPessoal.idEstado
      = this.responsavelAtual.pessoa.enderecoPessoal.estado
      = this.responsavelAtual.pessoa.enderecoPessoal.idCidade
      = this.responsavelAtual.pessoa.enderecoPessoal.cidade = "";
  }

  onEstadoEnderecoPessoalAlterado() {
    this.rolresponsaveisService.buscarCidadesPorEstado(this.responsavelAtual.pessoa.enderecoPessoal.idEstado).subscribe(data => {
      this.listaCidadesEnderecoPessoal = data;
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
      console.log("erro: " + error);
    });
  }

  onEstadoEnderecoFuncionalAlterado() {
    this.rolresponsaveisService.buscarCidadesPorEstado(this.responsavelAtual.pessoa.enderecoFuncional.idEstado).subscribe(data => {
      this.listaCidadesEnderecoFuncional = data;
    }, error => {
      this.alertService.mostraAlerta("", "Ocorreu um erro ao buscar as cidades para o estado selecionado:" + error);
      console.log("erro: " + error);
    });
  }

  adicionarTelefone() {
    if (this.telefoneParaAdicionar.dsContato != '' &&
      this.telefoneParaAdicionar.dsTipoContato != '') {
      let telefoneNovo = {
        "idContato": 0,
        "dsContato": this.telefoneParaAdicionar.dsContato,
        "dsTipoContato": this.telefoneParaAdicionar.dsTipoContato,
        "idTipoContato": 0
      };

      let tipoContatoTemp = this.listaTiposTelefone.filter((tipoContato) => this.telefoneParaAdicionar.dsTipoContato == tipoContato.dsTipoContato)[0];

      if (tipoContatoTemp != null) {
        telefoneNovo.idTipoContato = tipoContatoTemp.idTipoContato;
      }

      if (this.responsavelAtual.pessoa.telefones.findIndex(i => i.dsContato === telefoneNovo.dsContato) != -1) {
        this.alertService.mostraAlerta("", "Telefone já adicionado!");
      }
      else {
        this.responsavelAtual.pessoa.telefones.push(telefoneNovo);
        this.telefoneParaAdicionar.dsContato =
          this.telefoneParaAdicionar.dsTipoContato = '';
      }
    }
  }

  removerTelefone(telefone) {
    let index = this.responsavelAtual.pessoa.telefones.indexOf(telefone);
    this.responsavelAtual.pessoa.telefones.splice(index, 1);
  }

  cnpj_mask(v) {
    v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
    v = v.replace(/(\d{2})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    //de novo (para o segundo bloco de números)
    v = v.replace(/(\d{3})(\d)/, '$1/$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
    v = v.replace(/(\d{4})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
    return v;
  }

  validarCNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');

    if (cnpj == '') {
      this.cnpjInvalido = false;
      return false;
    }

    if (cnpj.length != 14) {
      this.cnpjInvalido = false;
      return false;
    }

    // Elimina CNPJs invalidos conhecidos
    if (cnpj == "00000000000000" ||
      cnpj == "11111111111111" ||
      cnpj == "22222222222222" ||
      cnpj == "33333333333333" ||
      cnpj == "44444444444444" ||
      cnpj == "55555555555555" ||
      cnpj == "66666666666666" ||
      cnpj == "77777777777777" ||
      cnpj == "88888888888888" ||
      cnpj == "99999999999999") {
      this.cnpjInvalido = true;
      return false;
    }

    let tamanho: any;
    let numeros: any;
    let digitos: any;
    let soma: any;
    let pos: any;
    let resultado: any;

    // Valida DVs
    tamanho = cnpj.length - 2
    numeros = cnpj.substring(0, tamanho);
    digitos = cnpj.substring(tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
      this.cnpjInvalido = true;
      return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2)
        pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
      this.cnpjInvalido = true;
      return false;
    }

    //this.cnpjInvalido = true;
    return true;
  }

}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-ocorrencia/modal-ocorrencia.ts